import { createAction } from '@reduxjs/toolkit';

import type {
  ModoDaSimulacao,
  TipoDeComando,
  IntencaoDeComando,
  EstadoSimulacao,
  ResultadoDoAvanco,
} from '../types';

export const intencaoRegistrada = createAction<{
  tipo: TipoDeComando;
  intencao: IntencaoDeComando;
}>('negociacaoSimulacao/intencaoRegistrada');

export const registroDaAssinaturaFinalizado = createAction<string>(
  'negociacaoSimulacao/registroDaAssinaturaFinalizado',
);

export const agenteSelecionado = createAction<string | null>(
  'negociacaoSimulacao/agenteSelecionado',
);

export const dadoAlterado = createAction<{ nome: string; valor: unknown }>(
  'negociacaoSimulacao/dadoAlterado',
);

/** Estado que chega fora de um thunk deste store (confirmação do anexo, no hook do navegador). */
export const estadoDaSimulacaoRecebido = createAction<EstadoSimulacao>(
  'negociacaoSimulacao/estadoRecebido',
);

/** Cada passo do avanço que o core confirmou: uma falha no meio não apaga o que já andou. */
export const progressoDoAvancoRecebido = createAction<ResultadoDoAvanco & { simulacaoId: string }>(
  'negociacaoSimulacao/progressoDoAvancoRecebido',
);

export const progressoDaExportacaoRecebido = createAction<{
  simulacaoId: string;
  carregados: number;
  total: number;
}>('negociacaoSimulacao/progressoDaExportacaoRecebido');

/** A tela do admin abriu: a superfície passa a ADMIN, com o fluxo da URL e o escritório dela. */
export const contextoDoAdminAberto = createAction<{ flowId: string; escritorioId: string | null }>(
  'negociacaoSimulacao/contextoDoAdminAberto',
);

export const escritorioDoAdminTrocado = createAction<string>(
  'negociacaoSimulacao/escritorioDoAdminTrocado',
);

/** A tela do admin saiu: o cliente, na mesma sessão, não pode herdar a superfície nem o escritório. */
export const contextoDoAdminFechado = createAction('negociacaoSimulacao/contextoDoAdminFechado');

export const modoDoAdminEscolhido = createAction<ModoDaSimulacao>(
  'negociacaoSimulacao/modoDoAdminEscolhido',
);

/** 409 CONFIGURACAO_ALTERADA de um comando: a tela avisa e oferece Reiniciar. */
export const configuracaoAlteradaDetectada = createAction<string>(
  'negociacaoSimulacao/configuracaoAlteradaDetectada',
);

/** Fechar a execução aberta nos logs: os passos saem da tela, e a próxima abre na página 1. */
export const passosDaExecucaoFechados = createAction(
  'negociacaoSimulacao/passosDaExecucaoFechados',
);
